/**
 * Resolves whether the License Plate field should be shown for the receipt portal.
 *
 * The receipt-portal context endpoint already resolves LPR for both a facility and
 * a facility group (server-side aggregate), so visibility simply reflects its
 * `lprEnabled` result. The field stays hidden until the context has loaded to avoid
 * a flash before the flag resolves.
 *
 * @param {boolean} lprEnabled Whether LPR is enabled, from the context endpoint.
 * @param {boolean} isContextLoaded Whether the context call has resolved.
 * @returns {{ show: boolean, isLoaded: boolean }} Whether to show the field and
 *   whether the context has resolved.
 */
const useLprVisibility = (lprEnabled, isContextLoaded) => {
  return { show: isContextLoaded === true && lprEnabled === true, isLoaded: isContextLoaded === true };
};

export default useLprVisibility;
